document.addEventListener('DOMContentLoaded', () => {
	// Add a dropdown toggle button before each sub-menu
	document.querySelectorAll('.menu-item-has-children .sub-menu').forEach(subMenu => {
		const button = document.createElement('button');
		button.className = 'dropdown-toggle';
		button.setAttribute('aria-expanded', 'false');
		button.innerHTML = '<span class="screen-reader-text"></span>';
		subMenu.parentNode.insertBefore(button, subMenu);
	});
	const menu = {
		// Remove open classes and aria attributes
		removeClasses(clicked) {
			document.body.classList.remove('menu-open');
			const target = document.getElementById(clicked.dataset.id);
			if (target) target.setAttribute('aria-expanded', 'false');
			document.querySelectorAll('.menu-toggle').forEach(el => {
				el.setAttribute('aria-expanded', 'false');
			});
		},
		// Add open classes and aria attributes
		addClasses(clicked) {
			document.body.classList.add('menu-open');
			const target = document.getElementById(clicked.dataset.id);
			if (target) target.setAttribute('aria-expanded', 'true');
			document.querySelectorAll('.menu-toggle').forEach(el => {
				el.setAttribute('aria-expanded', 'true');
			});
		},
		toggle(e) {
			if (e.currentTarget.classList.contains('menu-toggle-close')) {
				menu.removeClasses(e.currentTarget);
			} else {
				menu.addClasses(e.currentTarget);
			}
		},
		init() {
			document.querySelectorAll('.menu-toggle').forEach(toggle => {
				toggle.addEventListener('click', this.toggle);
			});
		}
	};

	// Dropdown toggle object (for sub-menus)
	const dropdown = {
		removeClasses(clicked) {
			clicked.setAttribute('aria-expanded', 'false');
			clicked.classList.remove('toggled-on');
			const subMenu = clicked.nextElementSibling;
			if (subMenu && subMenu.classList.contains('sub-menu')) {
				subMenu.classList.remove('toggled-on');
			}
		},
		addClasses(clicked) {
			clicked.setAttribute('aria-expanded', 'true');
			clicked.classList.add('toggled-on');
			const subMenu = clicked.nextElementSibling;
			if (subMenu && subMenu.classList.contains('sub-menu')) {
				subMenu.classList.add('toggled-on');
			}
		},
		toggle(e) {
			const clicked = e.currentTarget;
			if (clicked.classList.contains('toggled-on')) {
				dropdown.removeClasses(clicked);
			} else {
				dropdown.addClasses(clicked);
			}
		},
		init() {
			document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
				toggle.addEventListener('click', this.toggle);
			});
		}
	};
	menu.init();
	dropdown.init();
});